import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import registerBeforeHooks from './before'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history',
  linkActiveClass: 'active'
})

registerBeforeHooks(router)

export default router
